import { METHOD, PROVIDER } from '../Payment.constants';

export const getImage = ({ method, provider } = {}) => {
  let image;

  if (method === METHOD.APLAZAME) image = 'aplazame.png';
  else if (method === METHOD.BIZUM) image = 'bizum.png';
  else if (method === METHOD.CRIPTAN) image = 'criptan.png';
  else if (method === METHOD.OXXO) image = 'oxxo.png';
  else if (method === METHOD.TPV && provider === PROVIDER.OPENPAY) image = 'openpay.png';
  else if (method === METHOD.SCALAPAY) image = 'scalapay.png';

  return image;
};
